{
  "areaKeys": {
    "addr:*": {},
    "advertising": {
      "totem": true,
      "poster_box": true,
      "billboard": true
    },
    "aerialway": {
      "zip_line": true,
      "t-bar": true,
      "rope_tow": true,
      "platter": true,
      "mixed_lift": true,
      "magic_carpet": true,
      "j-bar": true,
      "goods": true,
      "gondola": true,
      "drag_lift": true,
      "chair_lift": true,
      "cable_car": true
    },
    "aeroway": {
      "taxiway": true,
      "runway": true,
      "parking_position": true,
      "jet_bridge": true
    },
    "allotments": {},
    "amenity": {
      "weighbridge": true,
      "bench": true
    },
    "area:highway": {},
    "attraction": {
      "water_slide": true,
      "train": true,
      "summer_toboggan": true,
      "river_rafting": true,
      "log_flume": true,
      "dark_ride": true
    },
    "boundary": {
      "administrative": true
    },
    "bridge:support": {},
    "building": {},
    "building:part": {},
    "cemetery": {},
    "club": {},
    "craft": {},
    "demolished:building": {},
    "disused:amenity": {},
    "disused:railway": {},
    "disused:shop": {},
    "emergency": {
      "yes": true,
      "private": true,
      "official": true,
      "no": true,
      "destination": true,
      "designated": true
    },
    "golf": {
      "path": true,
      "hole": true,
      "cartpath": true
    },
    "healthcare": {},
    "historic": {},
    "indoor": {
      "wall": true,
      "corridor": true
    },
    "industrial": {},
    "internet_access": {},
    "junction": {},
    "landuse": {},
    "leisure": {
      "track": true,
      "slipway": true
    },
    "man_made": {
      "video_wall": true,
      "torii": true,
      "quay": true,
      "pipeline": true,
      "pier": true,
      "groyne": true,
      "goods_conveyor": true,
      "gantry": true,
      "embankment": true,
      "dyke": true,
      "cutline": true,
      "crane": true,
      "carpet_hanger": true,
      "breakwater": true,
      "yes": true
    },
    "military": {
      "trench": true
    },
    "natural": {
      "valley": true,
      "tree_row": true,
      "strait": true,
      "ridge": true,
      "coastline": true,
      "cliff": true,
      "bay": true
    },
    "office": {},
    "pipeline": {},
    "piste:type": {
      "sleigh": true,
      "sled": true,
      "skitour": true,
      "nordic": true,
      "ice_skate": true,
      "hike": true,
      "downhill": true
    },
    "place": {},
    "playground": {
      "zipwire": true,
      "water": true,
      "tunnel_tube": true,
      "swing": true,
      "structure": true,
      "slide": true,
      "seesaw": true,
      "horizontal_bar": true,
      "hopscotch": true,
      "climbingwall": true,
      "bridge": true,
      "basketswing": true,
      "balancebeam": true,
      "activitypanel": true
    },
    "police": {},
    "polling_station": {},
    "power": {
      "portal": true,
      "minor_line": true,
      "line": true,
      "cable": true
    },
    "public_transport": {
      "platform": true
    },
    "residential": {},
    "seamark:harbour:category": {},
    "seamark:type": {},
    "shop": {},
    "telecom": {},
    "tourism": {
      "attraction": true,
      "artwork": true
    },
    "traffic_calming": {
      "rumble_strip": true,
      "mini_bumps": true,
      "island": true,
      "hump": true,
      "dip": true,
      "cushion": true,
      "choker": true,
      "chicane": true,
      "bump": true,
      "yes": true
    },
    "waterway": {
      "weir": true,
      "tidal_channel": true,
      "stream": true,
      "river": true,
      "lock_gate": true,
      "fish_pass": true,
      "drain": true,
      "ditch": true,
      "dam": true,
      "canal": true
    }
  }
}